'use client';

import { useFoldDescription } from '@/app/sales/components/description/useFoldDescription';
import { Button } from '@/components';
import { HTML } from '@/components/html';
import { ITimeRangeResponse } from '@/types';
import { Column, Element } from '@vuddy/components';
import { formatFullDateExceptSeconds2 } from '@vuddy/utils';
import { useState } from 'react';
import * as styles from './gachaIntroduce.css';

interface IGachaContentIntroduceProps {
  description?: string;
  requestDeliveryAddressTimeRange?: ITimeRangeResponse;
}

export const GachaContentIntroduce = ({
  description,
  requestDeliveryAddressTimeRange,
}: IGachaContentIntroduceProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isCalculating, isOverflown, htmlRefCallback } = useFoldDescription({
    description: description ?? '',
  });

  return (
    <Column
      borderRadius="radius_large"
      backgroundColor="whiteQuaternary"
      id="introduce">
      <Element
        paddingTop="padding_base"
        paddingBottom="gap_3xl"
        paddingX="padding_base"
        typography="titleSmall"
        color="whitePrimary">
        소개
      </Element>
      <Column
        className={styles.htmlWrapper({
          isExpanded,
          isOverflown,
          isCalculating,
        })}>
        {description ? (
          <Element
            paddingX="padding_base"
            paddingBottom="padding_base"
            color="whitePrimary"
            ref={htmlRefCallback}
            className={styles.html}>
            <HTML html={description} />
          </Element>
        ) : null}
        {requestDeliveryAddressTimeRange ? (
          <Column
            paddingX="padding_base"
            paddingBottom="padding_base"
            gap="gap_3xl">
            <Column gap="gap_base">
              <Element typography="bodyXsAccent" color="whitePrimary">
                리워드 배송 안내
              </Element>
              <ul className={styles.ul}>
                <li className={styles.li}>배송지 입력 기간:</li>
                <ul className={styles.ul}>
                  <li className={styles.li}>
                    {`${formatFullDateExceptSeconds2(requestDeliveryAddressTimeRange?.startAt)} ~
                    ${
                      requestDeliveryAddressTimeRange?.endAt
                        ? formatFullDateExceptSeconds2(
                            requestDeliveryAddressTimeRange?.endAt
                          )
                        : ''
                    }`}
                  </li>
                  <li className={styles.li}>
                    (리워드에 실물 수령이 있는 경우 해당합니다.)
                  </li>
                </ul>
                <li className={styles.li}>배송비: 무료</li>
                <li className={styles.li}>
                  실물 리워드를 받으시려면 반드시 배송지 입력을 완료해야 합니다.
                </li>
                <li className={styles.li}>
                  배송지 입력 기간이 지난 이후에는 배송 신청이 불가능하므로
                  반드시 기간 내에 신청해 주세요.
                </li>

                <li className={styles.li}>
                  가챠 실물 리워드는 판매 종료 후 일괄 제작 및 발송되며,
                  배송까지 최대 약 1개월이 소요될 수 있습니다.
                </li>
              </ul>
            </Column>
          </Column>
        ) : null}
      </Column>
      {(isOverflown || isExpanded) && (
        <>
          <Element
            paddingX="padding_large"
            paddingTop={isExpanded ? undefined : 'padding_base'}
            paddingBottom="padding_base"
            position="relative">
            {!isExpanded ? (
              <Column width="100%" height={40} className={styles.dimmed} />
            ) : null}
            <Button
              variant="outlineWhite"
              size="medium"
              onClick={() => setIsExpanded(isExpanded => !isExpanded)}
              fullWidth>
              {isExpanded ? '접기' : '더보기'}
            </Button>
          </Element>
        </>
      )}
    </Column>
  );
};
